module.exports = __webpack_public_path__ + "static/media/south-africa.81a39a30.svg";